import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Popconfirm, Button, Spin, message } from 'antd';
import folders from '../../Actions/folders';
import SelectsOrganization from './SelectsOrganization';
import PathTree from './PathTree';
import { getCopy } from '../../helpers';
import googleDrive from '../../Actions/googleDrive';
const { getGoogleData } = googleDrive.actions;
const { saveFoldersPath, addRemoveFolderOption, getFoldersData, selectFolder } = folders.actions;

class Folders extends Component {
	constructor(props) {
        super(props);
        this.saveFolder = this.saveFolder.bind(this);
        this.saveFolderIfAllowed = this.saveFolderIfAllowed.bind(this);
        this.updateDataFunction = this.updateDataFunction.bind(this);
        this.addDataFunction = this.addDataFunction.bind(this);
        this.deleteDataFunction = this.deleteDataFunction.bind(this);
    }
    
    componentDidMount() {
        this.props.getFoldersData();
        this.props.getGoogleData();
    }

  	render() {  
        let { folders, foldersSelected, isLoading, gDriveData } = this.props;
    	return (			
      		<Fragment>
                <div className="download-xmls-container-text">
			        Aquí podrás definir la estructura de carpetas en la que quieres que estén organizados los archivos XMLs al momento de descargarlos, solo selecciona los campos que deseas incluir en la ruta de carpetas.
		        </div>
                { foldersSelected && foldersSelected.length > 0 && 
                    <Fragment>
                        <SelectsOrganization data={foldersSelected} options = {folders} addDataFunction = {this.addDataFunction}  updateDataFunction = {this.updateDataFunction} deleteDataFunction={this.deleteDataFunction} id="folderDroppable" maxOptions={6} label="Organización de carpetas:"/>
                        <PathTree foldersSelected={foldersSelected} folders={folders.filter(f =>{return f.selected === true})} />
                    </Fragment>
                }
                <div className="confirmation-container">
                    <Popconfirm
                        title="Tiene activado Google Drive, a partir de este momento se creará una nueva carpeta con esta configuración. ¿Desea continuar?"
                        onConfirm={this.saveFolder}
                        okText="Si"
                        cancelText="No"
                        disabled={gDriveData.email === ''}
                    >
                        <Button style={{marginTop: '10px'}} onClick={this.saveFolderIfAllowed} type="primary">Guardar</Button>
                    </Popconfirm>
                </div>
                { isLoading &&
					<div className="loading-container">
						<Spin size="large" tip="Cargando" />
                    </div>
                }    
            </Fragment>
    	);
    }
    
    addDataFunction(data) {
        const { folders, foldersSelected } = this.props;
        let copyfoldersSelected = getCopy(foldersSelected);
        copyfoldersSelected.push(data);
        this.props.addRemoveFolderOption(folders);
        this.props.selectFolder(copyfoldersSelected);
    }

    updateDataFunction(options, data) {            
        this.props.addRemoveFolderOption(options);
        this.props.selectFolder(data);    
    }

    deleteDataFunction(data) {
        const { folders } = this.props;
        this.props.addRemoveFolderOption(folders);
        this.props.selectFolder(data.filter(x => x.selected));
    }

    saveFolderIfAllowed(){
        if (this.props.gDriveData.email === '') {
            this.saveFolder();
        }
    }

    saveFolder() {
        const { foldersSelected } = this.props;
        if(foldersSelected.length !== 0) {
            let foldersPath = foldersSelected.filter(folder => {
                return folder.selected ? folder.label : null
            });
            let path = foldersPath.map(f => f.pathName).join('/');        
            this.props.saveFoldersPath(path);
        } else {
            message.error('Favor de añadir por lo menos un campo', 5);
        }
                
    }    
}

const mapStateToProps = state => {    
	return {
        folders: state.folders.folders,
        foldersSelected: state.folders.foldersSelected,
        isLoading: state._genericComponents.loading.isCurrentlyLoading,
        gDriveData: state.googleDrive.data
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addRemoveFolderOption:(data) => {
            dispatch(addRemoveFolderOption(data));
        },
        saveFoldersPath:(data) => {
            dispatch(saveFoldersPath(data))
        },
        getFoldersData:() => {
            dispatch(getFoldersData());
        },
        selectFolder:(data) => {
            dispatch(selectFolder(data));
        },
        getGoogleData:() => {
			dispatch(getGoogleData());
		}
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Folders);
